type VisibilityFilter = '' | 'private' | 'team' | 'organization';
type StatusFilter = '' | 'draft' | 'published';
type SortOrder = 'newest' | 'oldest';

interface SearchFiltersProps {
  search: string;
  visibilityFilter: VisibilityFilter;
  statusFilter: StatusFilter;
  sortOrder: SortOrder;
  isTeamTab: boolean;
  onSearchChange: (value: string) => void;
  onVisibilityChange: (value: VisibilityFilter) => void;
  onStatusChange: (value: StatusFilter) => void;
  onSortChange: (value: SortOrder) => void;
}

export function SearchFilters({
  search,
  visibilityFilter,
  statusFilter,
  sortOrder,
  isTeamTab,
  onSearchChange,
  onVisibilityChange,
  onStatusChange,
  onSortChange,
}: SearchFiltersProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4 space-y-3">
      <div className="relative">
        <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/></svg>
        <input
          type="text"
          placeholder="Seite suchen…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-shadow"
        />
      </div>
      <div className="flex flex-wrap gap-4">
        {/* Visibility filter — only on "mine" tab */}
        {!isTeamTab && (
          <div>
            <label htmlFor="visibility-filter" className="block text-xs font-medium text-gray-500 mb-1">Sichtbarkeit</label>
            <select
              id="visibility-filter"
              value={visibilityFilter}
              onChange={(e) => onVisibilityChange(e.target.value as VisibilityFilter)}
              className="w-full sm:w-48 border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-900 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            >
              <option value="">Alle</option>
              <option value="private">Privat</option>
              <option value="team">Team</option>
            </select>
          </div>
        )}
        {/* Status filter — only on "mine" tab */}
        {!isTeamTab && (
          <div>
            <label htmlFor="status-filter" className="block text-xs font-medium text-gray-500 mb-1">Status</label>
            <select
              id="status-filter"
              value={statusFilter}
              onChange={(e) => onStatusChange(e.target.value as StatusFilter)}
              className="w-full sm:w-48 border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-900 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            >
              <option value="">Alle</option>
              <option value="draft">Entwurf</option>
              <option value="published">Fertig</option>
            </select>
          </div>
        )}
        {/* Sort order */}
        <div>
          <label htmlFor="sort-order" className="block text-xs font-medium text-gray-500 mb-1">Sortierung</label>
          <select
            id="sort-order"
            value={sortOrder}
            onChange={(e) => onSortChange(e.target.value as SortOrder)}
            className="w-full sm:w-48 border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-900 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          >
            <option value="newest">Neueste zuerst</option>
            <option value="oldest">Älteste zuerst</option>
          </select>
        </div>
      </div>
    </div>
  );
}
